import React from 'react';
import { Authenticator } from '@aws-amplify/ui-react';
import * as Sentry from "@sentry/react";
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { MDBSpinner } from 'mdb-react-ui-kit';
import App from './App';
import DOMErrorBoundary from './components/DOMErrorBoundary';

const PublicChatbot = React.lazy(() => import('./pages-user/public-chatbot/PublicChatbot'));

const AuthLayer = () => (
    <BrowserRouter>
        <Sentry.ErrorBoundary fallback={<p>An error has occurred. We've been notified and are working on a fix.</p>}>
            <DOMErrorBoundary fallback={<p>An error has occurred. We've been notified and are working on a fix.</p>}>
                <Routes>
                    <Route path="/cp-ai" element={
                        <React.Suspense fallback={<div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}><MDBSpinner color="primary" /></div>}>
                            <PublicChatbot />
                        </React.Suspense>
                    } />
                    <Route path="*" element={
                        <Authenticator.Provider>
                            <App />
                        </Authenticator.Provider>
                    } />
                </Routes>
            </DOMErrorBoundary>
        </Sentry.ErrorBoundary>
    </BrowserRouter>
);

export default AuthLayer;
